export enum OrbitRemoveProjectStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  REMOVED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
